module.exports = __webpack_public_path__ + "static/img/ssc.1c681a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ssc.png
// module id = yAHu
// module chunks = 7